import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE, CUSTOM_TABLE_FIELD_TYPES_PARAMETERS } from '../../_config/consts';
import MDButton from '../MDButton/MDButton';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 60,
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -8,
    marginTop: 5,
    marginBottom: 5,
    width: 'max-content',
  },
  addButton: {
    backgroundColor: BLUE,
    color: 'white',
    '&:hover': {
      backgroundColor: BLUE,
    },
  },
});

@connect((state) => ({ 
  customTables: state.customTables,
  themeName: state.settings.items.theme.data.themeName 
}))
class CustomTableFields extends React.Component {
  render() {
    const {
      classes,
      customTables: { selectedCustomTable },
      onAddField,
      onEditField,
      onDeleteField,
    } = this.props;

    return (
      <div style={{ marginTop: 20 }}>
        <Card>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <h4 className={classes.tableColumnText}>
                      <Entity entity="fields" />
                    </h4>
                    <MDButton
                      title={<Entity entity="addCustomTableField" />}
                      onClick={onAddField}
                      containerStyle={{ margin: 10}}
                    />
                  </div>
                  </TableCell>
              </TableRow>
              <TableRow>
                <TableCell><h4 className={classes.tableColumnText}><Entity entity="fieldName" /></h4></TableCell>
                <TableCell><h4 className={classes.tableColumnText}><Entity entity="description" /></h4></TableCell>
                <TableCell><h4 className={classes.tableColumnText}><Entity entity="isSearchField" /></h4></TableCell>
                {/* <TableCell><h4 className={classes.tableColumnText}><Entity entity="externalReference" /></h4></TableCell> */}
                <TableCell><h4 className={classes.tableColumnText} style={{ minWidth: 145 }}><Entity entity="actions" /></h4></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedCustomTable && selectedCustomTable.fields && _.map(selectedCustomTable.fields, (field) => (
                <TableRow key={field.id} className={classes.row}>
                  <TableCell>
                    <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 16, marginBottom: 5 }}>{field.name}</h5>
                    <h5 style={{ lineHeight: '1.5', fontSize: 14, marginTop: 0 }}>{CUSTOM_TABLE_FIELD_TYPES_PARAMETERS[field.type] && CUSTOM_TABLE_FIELD_TYPES_PARAMETERS[field.type].string ? <Entity key={field.type} entity={CUSTOM_TABLE_FIELD_TYPES_PARAMETERS[field.type].string} />  : field.type}</h5>
                  </TableCell>
                  <TableCell>
                    <h5 style={{ lineHeight: '1.5', fontSize: 14 }}>{field.description || '---'}</h5>
                  </TableCell>
                  <TableCell>
                    <h5 style={{ lineHeight: '1.5', fontSize: 14 }}>{field.isSearchField ? 'Yes' : 'No'}</h5>
                  </TableCell>
                  {/* <TableCell>
                    <h5 style={{ lineHeight: '1.5', fontSize: 14 }}>{field.externalReference || '---'}</h5>
                  </TableCell> */}
                  <TableCell>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Button
                        onClick={() => onEditField(field)}
                        className={classes.buttonPositive}
                      >
                        <Entity entity="edit" />
                        <EditIcon style={{ fontSize: 15, marginLeft: 5 }} />
                      </Button>
                      <Button
                        onClick={() => onDeleteField(field)}
                        className={classes.button}
                      >
                        <Entity entity="delete" />
                        <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
              {(!selectedCustomTable || !selectedCustomTable.fields || selectedCustomTable.fields.length === 0) && (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                    <h5 style={{ color: '#666' }}><Entity entity="noFields" /></h5>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Card>
      </div>
    );
  }
}

export default withStyles(styles)(CustomTableFields); 